// extracted by mini-css-extract-plugin
module.exports = {"totals":"Total_totals__2vs28","country-stats":"Total_country-stats__3tUrU","updated":"Total_updated__1J58q","boxes":"Total_boxes__j8R2R"};